import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { PRESENTS_SEO as S } from "../../data/presentsSeo";
import { GIFT_PRESETS } from "../../data/giftPresets";

const box = "rounded-[18px] border-[3px] border-[#FFC15E] bg-white p-3 text-[#3b1800] sm:p-4";
const money = (t: string) => t.split("£").flatMap((part, i) => (i ? [<span key={i} className="font-sans font-black">£</span>, part] : [part]));
const h2 = "font-comic text-xl text-[#FF5D1F] sm:text-2xl";

function GiftLinks({ occasion, testId }: { occasion: boolean; testId: string }) {
  return (
    <ul className={`mt-2 grid gap-1.5 ${occasion ? "" : "sm:grid-cols-2 lg:grid-cols-3"}`} data-testid={testId}>
      {GIFT_PRESETS.filter((g) => !!g.occasion === occasion).map((g) => (
        <li key={g.slug}><Link to={`/gifts/${g.slug}`} className="block rounded-xl border-2 border-[#FFD9A8] bg-[#FFF6E6] px-3 py-1.5 transition-colors hover:bg-[#FFE9C7]" data-testid={`presents-seo-link-${g.slug}`}>
          <h3 className="font-comic text-sm">{money(g.heading)}</h3><p className="text-xs text-[#6b3a12]">{g.blurb}</p>
        </Link></li>
      ))}
    </ul>
  );
}

export function PresentsSeoSection() {
  return (
    <section className="mt-4 grid gap-2 md:grid-cols-2" data-testid="presents-seo-section">
      <div className={`${box} md:col-span-2`} data-testid="presents-seo-how">
        <h2 className={h2}>How the gift finder works</h2>
        <ol className="mt-2 grid gap-2 sm:grid-cols-3">
          {S.steps.map((s, i) => (
            <li key={s.h} className="rounded-xl bg-[#FFF6E6] p-2.5">
              <h3 className="flex items-center gap-1.5 font-comic text-base"><span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FF5D1F] text-xs text-white">{i + 1}</span>{s.h}</h3>
              <p className="mt-0.5 text-sm font-semibold">{s.p}</p>
            </li>
          ))}
        </ol>
      </div>
      <div className={`${box} md:col-span-2`}><h2 className={h2}>Gift ideas by recipient</h2><GiftLinks occasion={false} testId="presents-seo-recipients" /></div>
      <div className={box}><h2 className={h2}>Gift ideas by occasion</h2><GiftLinks occasion testId="presents-seo-occasions" /></div>
      <div className={box} data-testid="presents-seo-budgets">
        <h2 className={h2}>Gift ideas by budget</h2>
        {S.budgets.map((b) => <div key={b.h} className="mt-2"><h3 className="font-comic text-base">{money(b.h)}</h3><p className="text-sm font-semibold">{b.p}</p></div>)}
      </div>
      <div className={`${box} md:col-span-2`} data-testid="presents-seo-tips">
        <h2 className={h2}>Tips for choosing a present</h2>
        <ul className="mt-2 list-disc space-y-1 pl-5 text-sm font-semibold">{S.tips.map((t) => <li key={t}>{t}</li>)}</ul>
      </div>
      <div className={`${box} md:col-span-2`} data-testid="presents-seo-faq">
        <h2 className={h2}>Gift finder FAQ</h2>
        <div className="mt-2 grid items-start gap-1.5 md:grid-cols-2">
          {S.faqs.map((f, i) => (
            <details key={f.q} className="group rounded-xl border-2 border-[#FFD9A8] bg-[#FFF6E6] px-3 py-2" data-testid={`presents-faq-item-${i}`}>
              <summary className="flex cursor-pointer list-none items-center justify-between gap-2 font-comic text-sm"><h3>{money(f.q)}</h3><ChevronDown className="h-4 w-4 shrink-0 transition-transform group-open:rotate-180" strokeWidth={3} /></summary>
              <p className="mt-1 text-sm text-[#6b3a12]">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
